import { render, staticRenderFns } from "./CommissionOLdForm.vue?vue&type=template&id=7ad6a8b0&"
import script from "./CommissionOLdForm.vue?vue&type=script&lang=js&"
export * from "./CommissionOLdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports